<ng-container *ngIf="maintenance">
  <maintenance></maintenance>
</ng-container>

<div [style.display]="maintenance ? 'none' : 'block'">
  <router-outlet></router-outlet>
  <de-report-issues></de-report-issues>
</div>
